import _ from "@lodash";
import XAPPService from "app/Core/services/XAPPService";
import { GET_TAG_FUNCIONALIDADE, TagFuncionalidadeListState } from "app/ERP/TagFuncionalidade/Store/Actions/TagFuncionalidadeActions";

export const GET_EMPRESAPRODUTOS = "{EMPRESAPRODUTO APP] GET PRODUTOS";
export const GET_EMPRESAPRODUTO = "{EMPRESAPRODUTO APP] GET PRODUTO";
export const GET_TEMPLATE = "{EMPRESAPRODUTO APP] GET TEMPLATE";

export const OPEN_NEW_EMPRESAPRODUTO_DIALOG = "{EMPRESAPRODUTO APP] OPEN NEW PRODUTO DIALOG";
export const CLOSE_NEW_EMPRESAPRODUTO_DIALOG = "{EMPRESAPRODUTO APP] CLOSE NEW PRODUTO DIALOG";
export const OPEN_EDIT_EMPRESAPRODUTO_DIALOG = "{EMPRESAPRODUTO APP] OPEN EDIT PRODUTO DIALOG";
export const CLOSE_EDIT_EMPRESAPRODUTO_DIALOG = "{EMPRESAPRODUTO APP] CLOSE EDIT PRODUTO DIALOG";

export const EMPRESAPRODUTO_REMOVE = "{EMPRESAPRODUTO APP] PRODUTO REMOVE";
export const ADD_EMPRESAPRODUTO = "{EMPRESAPRODUTO APP] ADD PRODUTO";

export const EMPRESAPRODUTO_WARNING = "{EMPRESAPRODUTO APP] PRODUTO WARNING";
export const EMPRESAPRODUTO_INFO = "{EMPRESAPRODUTO APP] PRODUTO INFO";
export const EMPRESAPRODUTO_ERROR = "{EMPRESAPRODUTO APP] PRODUTO ERROR";
export const EMPRESAPRODUTO_SELECIONAR_WARNING = "{EMPRESAPRODUTO APP] PRODUTO SELECIONAR WARNING";
export const EMPRESAPRODUTO_SELECIONAR_INFO = "{EMPRESAPRODUTO APP] PRODUTO SELECIONAR INFO";
export const EMPRESAPRODUTO_SELECIONAR_ERROR = "{EMPRESAPRODUTO APP] PRODUTO SELECIONAR ERROR";


const ListState =
    [
        "idpessoaformulario",
        "idpessoa",
        "idparent",
        "nome",
        "unidademedida",
        "valor",
        "valordescricao",
        "tipo",
        "tipodescricao",
        "formulario",
        "statusregistro",
        "statusregistrodescricao",
        "usrins",
        "usrupt",
        "datainsdescricao",
        "datauptdescricao",
        "totalrows",
        "paginas",
    ];

const AddState =
    [
        "idparent",
        "formulario",
        "idpessoa",
        "tipo",
    ];

const UpdateState =
    [
        "formulario",
        "idparent",
    ];

export function get(_AIDPessoaFormulario, _AParams) {

    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "pessoaformulario.idpessoaformulario", "Operador": "=", "Valor": _AIDPessoaFormulario }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "Produtos", AActions, "spvwempresaproduto", ListState, "SELECIONAR", AConditionsAND, AConditionsOR);

        AConditionsAND = [{ "Campo": "tagfuncionalidade.tipo", "Operador": "=", "Valor": "produto" }];
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "tagfuncionalidade", AActions, "spvwtagfuncionalidade", TagFuncionalidadeListState, "SELECIONAR", AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_EMPRESAPRODUTO,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data[0] : "",
                    })
                    , dispatch({
                        type: GET_TAG_FUNCIONALIDADE,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAPRODUTO_SELECIONAR_ERROR,
                    payload: error
                });
            });
    };
}

export function list(_AAction, _AParams, _AFilter = null, _APagina = 1, _ATarget = null, _ACallback = null) {

    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        var ATarget = !_.isNull(_ATarget) ? _ATarget : "spvwempresaproduto";

        if (_AFilter !== null) {
            if (_AFilter.AND !== undefined && _AFilter.AND !== null) {
                AConditionsAND = AConditionsAND.concat(_AFilter.AND);
            }

            if (_AFilter.OR !== undefined && _AFilter.OR !== null) {
                AConditionsOR = AConditionsOR.concat(_AFilter.OR);
            }
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "Produtos", AActions, ATarget, ListState, _AAction, AConditionsAND, AConditionsOR, _APagina);

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) => {
                Promise.all([
                    dispatch({
                        type: GET_EMPRESAPRODUTOS,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                        pagina: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].pagina : 1,
                    })
                ]);
                if (!_.isNull(_ACallback)) {
                    _ACallback();
                }
            }
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAPRODUTO_SELECIONAR_ERROR,
                    payload: error
                });
            });
    };
}

export function openNewDialog() {
    return {
        type: OPEN_NEW_EMPRESAPRODUTO_DIALOG
    };
}

export function closeNewDialog() {
    return {
        type: CLOSE_NEW_EMPRESAPRODUTO_DIALOG
    };
}

export function openEditDialog(data) {
    return {
        type: OPEN_EDIT_EMPRESAPRODUTO_DIALOG,
        data
    };
}

export function closeEditDialog() {
    return {
        type: CLOSE_EDIT_EMPRESAPRODUTO_DIALOG
    };
}

export function save(_AValue, _AParams, _ACallback = null) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        var AAction = "INSERIR";

        if (_AValue.idpessoaformulario) {
            AAction = "ATUALIZAR";
            AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AValue.idpessoaformulario }];
            AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", AAction, _AValue, "idpessoaformulario", AConditionsAND, AConditionsOR, 1, UpdateState);
        }
        else {
            AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", AAction, _AValue, "idpessoaformulario", AConditionsAND, AConditionsOR, 1, AddState);
            if (_AValue.idparent) {
                AActions = XAPPService.XappCustomActionFactory(_AParams.empresa, AActions, "pessoaformulario", "VINCULAR-FORMULARIO-BY-NOME", _AValue, "idpessoaformulario", AConditionsAND, AConditionsOR, 1);
            }
        }

        XAPPService.XappCustomAction(AActions, _AParams, "spdoactionpessoaformulario", "CUSTOM")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAPRODUTO_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => {
                        if (!_.isNull(_ACallback)) {
                            _ACallback()
                        }
                    })
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAPRODUTO_INFO,
                            payload: response.info,
                            id: response.ultimoidinserido
                        })
                    ]).then(() => {
                        if (!_.isNull(_ACallback)) {
                            _ACallback()
                        }
                    })
                }
            }

            ).catch(error => {
                return dispatch({
                    type: EMPRESAPRODUTO_ERROR,
                    payload: error
                });
            });
    };
}

export function acaoRegistro(_AValue, _AParams, _AAction, _ACallback = null) {
    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AValue.idpessoaformulario }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", _AAction, "", "", AConditionsAND, AConditionsOR);

        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: EMPRESAPRODUTO_REMOVE
                    })
                ]).then(() => {
                    if (!_.isNull(_ACallback)) {
                        _ACallback()
                    }
                })
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAPRODUTO_ERROR,
                    payload: error
                });
            });
    };
}

export function getTemplate() {
    return (dispatch) => {

        XAPPService.XappGetTemplateAction("pessoa", "118")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_TEMPLATE,
                        payload: response,
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAPRODUTO_SELECIONAR_ERROR,
                    payload: error
                });
            });
    };
}

export function clearReducer() {
    return {
        type: GET_EMPRESAPRODUTOS,
        data: null,
        pagina: 1,
    }
}